import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import ModalPopupView from 'views/main/Modal/ModalPopupView';
import customFooterHtml from 'templates/privacy/PrivacyAlertFooterView.html';

var Events = {
    ON_SAVE: 'ON_SAVE'
};

var PrivacyAlertModalView = ModalPopupView.extend({
    events: {
        'click .confirm': 'onSaveClicked',
        'click .cancel': 'onCloseClicked'
    },

    footerTemplate: _.template(customFooterHtml),

    onSaveClicked: function() {
        this.trigger(Events.ON_SAVE);
        this.close();
    },

    onCloseClicked: function() {
        this.close();
    }
});

PrivacyAlertModalView.Events = Events;
export default PrivacyAlertModalView;
